/**
 * Utility functions for 2FA authentication flow
 */

/**
 * Builds a login data object for 2FA authentication flow
 * @param {Object} payload - Original login request payload
 * @param {Object} responseData - Response data from authentication service
 * @param {Boolean} accessCodeFlag - Whether this is the new 2FA flow
 * @param {String} effectiveType - User type: 'CLIENT' or 'SELLER'
 * @returns {Object} Login data object with all required fields
 */
export function buildAuth2FALogin(payload, responseData, accessCodeFlag, effectiveType) {
    if (payload && typeof payload !== 'object') {
        throw new TypeError('payload must be an object or null');
    }

    if (responseData && typeof responseData !== 'object') {
        throw new TypeError('responseData must be an object or null');
    }

    if (typeof effectiveType !== 'string' || !effectiveType) {
        throw new TypeError('effectiveType must be a non-empty string');
    }

    return {
        username: (payload && payload.username) || '',
        password: (payload && payload.password) || '',
        type: effectiveType,
        isIntegration: (payload && (payload.isIntegration === true || payload.isIntegration === 'true')),
        redirect_url: (payload && payload.redirect_url) || null,
        client_id: (payload && payload.client_id) || null,
        hash: (payload && payload.hash) || null,
        access_code_flag: accessCodeFlag,
        challenge_id: (responseData && responseData.challenge_id) || null
    };
}

/**
 * Creates a Vuex-safe version of login data by removing the password
 * @param {Object} loginData - Login data object (from buildAuth2FALogin)
 * @returns {Object} Login data object with password set to empty string
 */
export function redactPassword(loginData) {
    if (!loginData || typeof loginData !== 'object') {
        throw new TypeError('loginData must be a valid object');
    }

    if (!loginData.password) {
        console.warn('redactPassword: loginData has no password field');
    }

    return Object.assign({}, loginData, {
        password: ''
    });
}